.layoutContainer {
	display: flex;
	flex-direction: column;
	height: 100vh;
	width: 100%;
	overflow: hidden;

	&.mobile {
		height: auto;
		min-height: 100vh;
	}
}

.mainContent {
	display: flex;
	flex: 1;
	overflow: hidden;
	position: relative;
	height: calc(100vh - 8.5vh);
}

.sidebarWrapper {
	flex-shrink: 0;
	z-index: 99;
	position: fixed;
	left: 0;
	top: 8.5vh;
	height: calc(100vh - 8.5vh);
}

.contentWrapper {
	flex: 1;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	background-color: #f6f7fb;
	transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	width: 100%;

	&.collapsed {
		margin-left: 64px;
		width: calc(100% - 64px);
	}

	&.expanded {
		margin-left: 240px;
		width: calc(100% - 240px);
	}
}

.normalContent {
	overflow-y: auto;
	height: 100%;
	background-color: #f6f7fb;

	&::-webkit-scrollbar {
		width: 5px;
		height: 5px;
	}

	&::-webkit-scrollbar-track {
		background: #a8a8a8;
	}

	&::-webkit-scrollbar-thumb {
		background: #9ca3af;
		border-radius: 4px;

		&:hover {
			background: #6b7280;
		}
	}
}

.mobileContent {
	border-bottom: 2px solid #f6f7fb;
	background-color: white;
	height: 100%;
	overflow-y: scroll;

	&.login {
		height: 100%;
		background-color: #eff0f2;
	}
}

@media (max-width: 768px) {
	.contentWrapper {
		margin-left: 0 !important;

		&.expanded {
			margin-left: 0 !important;
		}
	}

	.sidebarWrapper {
		position: fixed;
		top: 0;
		left: 0;
		height: 100vh;
		z-index: 1000;
	}
}

@media print {
	.sidebarWrapper {
		display: none !important;
	}

	.contentWrapper {
		margin-left: 0 !important;
	}
}
